import { render } from "./admin-password.vue?vue&type=template&id=b55e443e"
import script from "./admin-password.vue?vue&type=script&lang=js"
export * from "./admin-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__